import axios from 'axios'
import { AUTH_REFRESH } from '@/config/api/endpoints'
import { authEndpointUrl } from './authEndpointUrl.js'
import { normalizeLoginResponse } from './normalizeLoginResponse.js'

// Bare axios (not the shared client) so the refresh call can never recurse
// through the client's 401 → refresh response interceptor.
export async function refreshAccessToken(refreshToken) {
  if (!refreshToken?.trim()) return null
  try {
    const { data } = await axios.post(
      authEndpointUrl(AUTH_REFRESH),
      { refresh_token: refreshToken },
      { timeout: 30_000 },
    )
    const normalized = normalizeLoginResponse(data)
    if (!normalized.success) return null
    return normalized.data
  } catch {
    return null
  }
}
